import React from "react";
import { useParams } from "react-router-dom";
import { Flame } from "lucide-react";
import useSharedPodcastAudio from "./useSharedPodcastAudio";
import CircularPodcastPlayer from "./CircularPodcastPlayer";
import "./PodcastListenPage.css";

export default function PodcastListenPage() {
  const { builderId, runId } = useParams();
  const { url, loading, error } = useSharedPodcastAudio(builderId, runId);

  return <main className="podcast-listen-page">
    <section className="podcast-listen-card" aria-labelledby="podcast-listen-title">
      <header className="podcast-listen-brand">
        <Flame size={24} strokeWidth={2.2} aria-hidden="true" />
        <span><strong>WUI-Cast</strong></span>
      </header>
      {loading ? <div className="podcast-listen-message" role="status">Loading your podcast…</div> :
        error ? <div className="podcast-listen-message" role="alert">{error}</div> :
        <CircularPodcastPlayer src={url} builderId={builderId} runId={runId}>
          <div className="podcast-listen-details">
            <p className="podcast-listen-builder-id">{builderId}</p>
            <h1 id="podcast-listen-title">My Podcast</h1>
          </div>
        </CircularPodcastPlayer>}
    </section>
  </main>;
}
